var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPropertyBuyer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 66,
    viewBox: "0 0 86.49 65.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:none;stroke:#273133;stroke-miterlimit:10;stroke-width:2.07px}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.2,
    cy: 20.69,
    stroke: "#273133",
    className: "cls-1",
    rx: 10.26,
    ry: 18.19
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M74.96 17.88v39.68M68.48 22.28l6.35 9.77M80.12 22.24l-5.04 8.1M83.5 58.06H.11M83.66 64.4H0M45.41 37.44H21.19v-19.7l11.95-7.43 12.27 7.43v19.7z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M33.77 25.44h6.78v11.84h-6.78zM25.46 20.81h4.76v4.95h-4.76z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273133",
    d: "M8.29 1.03h50.55v42.74H8.29zM31.49 44.01h4.88v14.16h-4.88z",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyBuyer);
export default __webpack_public_path__ + "static/media/property_buyer.2ef9a45854c6d4526fba3ff5b0f46a8f.svg";
export { ForwardRef as ReactComponent };